import React from "react";
import classNames from "classnames";
import { host } from "../../config/openapi";
import "./styles.less";

export const CardProduct = ({
  title,
  apiNumber,
  icon,
  url,
  widthPercent,
  align = false,
  spacing = 24,
}) => {
  return (
    <div
      className={classNames(
        "open-page-api-card",
        align ? "open-page-api-card--align" : ""
      )}
      onClick={() => {
        window.open(host + url);
      }}
      style={{
        width: widthPercent
          ? `calc(${25 * widthPercent}% - ${
              (spacing * (widthPercent - 1)) / widthPercent
            }px)`
          : `calc(25% - ${(spacing * 3) / 4}px)`,
      }}
    >
      <i
        className={classNames(
          "open-page-api-card-icon icon website-icon",
          icon
        )}
      ></i>
      <div className="open-page-api-card-content">
        <div className="open-page-api-card-content__title">{title}</div>
        <div className="open-page-api-card-content__desc">
          {apiNumber}
          <span>API</span>
        </div>
      </div>
    </div>
  );
};
